module.exports = __webpack_public_path__ + "assets/img/barrel-attack.d782386d.png";